import React from 'react'
import { Outlet } from 'react-router-dom'

const Admin = () => {
  return (
    <>
     <div className="main-content-area">
        {<Outlet />}
      </div>
    </>
  )
}

export default Admin